import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from '_common/hooks';

type PrivateRouteProps = {
  children: React.ReactNode;
};

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const location = useLocation();
  const authenticated = useSelector((state) => state.auth.authenticated);
  const forcePasswordUpdate = useSelector((state) => state.auth.isUpdatePasswordForced);
  const mustUpdatePassword = forcePasswordUpdate && !location.pathname.includes('updatepassword');

  if (!authenticated || mustUpdatePassword) {
    return <Navigate to="/auth/signin" state={{ from: location }} replace />;
  }
  return children;
};

export default PrivateRoute;
